import { render } from "./BasicDataWelcome.vue?vue&type=template&id=233e04ed"
import script from "./BasicDataWelcome.vue?vue&type=script&lang=js"
export * from "./BasicDataWelcome.vue?vue&type=script&lang=js"
script.render = render

export default script